import axios from "axios"

const controller = "/opciones"

const OpcionesService = {
    getCategorias: async (request) => {
        const { data } = await axios.post(`${controller}/getCategorias`, request)
        return data
    },
    getTiposProducto: async (request) => {
        const { data } = await axios.post(`${controller}/getTiposProducto`, request)
        return data
    },
    getMarcas: async (request) => {
        const { data } = await axios.post(`${controller}/getMarcas`, request)
        return data
    },
    getUnidadesMedida: async (request) => {
        const { data } = await axios.post(`${controller}/getUnidadesMedida`, request)
        return data
    },
    getCentrosCosto: async (request) => {
        const { data } = await axios.post(`${controller}/getCentrosCosto`, request)
        return data
    },
    getAlmacenes: async (request) => {
        const { data } = await axios.post(`${controller}/getAlmacenes`, request)
        return data
    },
    getTiposTransferencias: async (request) => {
        const { data } = await axios.post(`${controller}/getTiposTransferencias`, request)
        return data
    },
    getEstados: async (request) => {
        const { data } = await axios.post(`${controller}/getEstados`, request)
        return data
    },
    getTiposCaja: async (request) => {
        const { data } = await axios.post(`${controller}/getTiposCaja`, request)
        return data
    },
    getCajaEstados: async (request) => {
        const { data } = await axios.post(`${controller}/getCajaEstados`, request)
        return data
    },

    getOpciones: async (request) => {
        const { data } = await axios.post(`${controller}/getOpciones`, request)
        return data
    },
}

export default OpcionesService